import { css } from '@emotion/react'

import Developer from 'gatsby-theme-marketplace-base/src/components/Developer'
import mediaQueries from 'gatsby-theme-marketplace-base/src/layout/media-queries'

const wrapperCss = css`
  margin-top: -30px;

  ${mediaQueries.smallScreen()} {
    margin-right: -32px;
    margin-left: -32px;
    padding-right: 0;
  }

  ${mediaQueries.mediumScreen()} {
    margin-left: 0;
    padding-right: 0;
  }

  ${mediaQueries.xlargeScreen()} {
    margin-right: -60px;
    padding-right: 0;
  }
`

export default (props) => <Developer hideSidebar css={wrapperCss} {...props} />
